import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import loadable from '@loadable/component';
import { toAbsoluteUrl } from 'utils/AssetsHelpers';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import { userActiveSchoolSelector } from 'store/user';

import ForgotPassword from 'components/links/ForgotPassword';

const LoginJWT = loadable(() => import('./LoginJWT'));
// const LoginFacebook = loadable(() => import('./LoginFacebook'));
// const LoginGoogle = loadable(() => import('./LoginGoogle'));

export const Login = () => {
  const intl = useIntl();

  const activeSchool = useSelector(userActiveSchoolSelector);

  return (
    <React.Fragment>
      <Card sx={{ width: '100%' }}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', p: 3 }}>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'space-between',
              mb: 2
            }}
          >
            <Typography color='textPrimary' gutterBottom variant='h4'>
              {intl.formatMessage({ id: 'login.login' })}
            </Typography>
          </Box>

          <Box sx={{ flexGrow: 1, mt: 2 }}>
            <LoginJWT />
          </Box>

          <Divider sx={{ my: 3 }} />

          {activeSchool?.config?.mobile_android_url || activeSchool?.config?.mobile_ios_url ? (
            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
              {activeSchool?.config?.mobile_ios_url ? (
                <img
                  style={{ cursor: 'pointer', width: '150px' }}
                  onClick={() => window.open(activeSchool?.config?.mobile_ios_url, '_blank')}
                  src={`${toAbsoluteUrl(`/media/images/app_store.png`)}`}
                />
              ) : null}

              {activeSchool?.config?.mobile_android_url ? (
                <img
                  style={{ cursor: 'pointer', width: '150px' }}
                  onClick={() => window.open(activeSchool?.config?.mobile_android_url, '_blank')}
                  src={`${toAbsoluteUrl(`/media/images/play_store.png`)}`}
                />
              ) : null}
            </Box>
          ) : null}

          {/* <Box sx={{ flexGrow: 1 }}>
              <LoginFacebook />
            </Box> */}

          {/* <Box sx={{ flexGrow: 1, marginTop: 2 }}>
              <LoginGoogle />
            </Box> */}

          {/* <Divider sx={{ my: 3 }} /> */}

          <Box sx={{ flexGrow: 1, textAlign: 'center' }}>
            <ForgotPassword />
          </Box>
        </CardContent>
      </Card>
    </React.Fragment>
  );
};

export default Login;
